import { createReducer, on } from '@ngrx/store';
import {
  IDeviceConfiguration,
  IFileData,
  ISpace,
  IUpdateDevicesInformation,
  IblobDetails,
  Shift,
} from 'src/app/core/models/configuration.model';
import { ConfigurationApiActions } from '../../actions/configuration-api.actions';
import { ISelectItem } from '@ra-web-tech-ui-toolkit/components';

export const configurationApiFeatureKey = 'configurationApi';

export interface ConfigurationApiState {
  spaces: ISpace[];
  currentSpace: ISpace | undefined;
  shifts: Shift[];
  error: any;
  saasToken: string | undefined;
  progress: number;
  loading: boolean;
  timeZones: ISelectItem[];
  blobDetails: IblobDetails;
  devicesInformation: IDeviceConfiguration;
  isUploadSuccessful: boolean | undefined;
  exportURL: string;
  isUpdateSuccessful: boolean | undefined;
  isLoading: boolean | undefined;
  updateDevicesInformation: IUpdateDevicesInformation;
}

export const initialState: ConfigurationApiState = {
  spaces: [],
  currentSpace: undefined,
  shifts: [],
  error: {},
  saasToken: undefined,
  timeZones: [],
  progress: 0,
  loading: false,
  blobDetails: {
    token: '',
    blobUrl: '',
  },
  devicesInformation: {
    tableData: [],
    existingAssets: [],
  },
  updateDevicesInformation: {
    isFileCorrect: undefined,
    existingAssets: [],
  },
  isUploadSuccessful: undefined,
  exportURL: '',
  isUpdateSuccessful: undefined,
  isLoading: undefined,
};

export const reducer = createReducer(
  initialState,
  on(ConfigurationApiActions.loadSpaces, (state) => {
    return {
      ...state,
      spaces: [],
      currentSpace: { space: [] },
    };
  }),
  on(ConfigurationApiActions.loadSpacesSuccess, (state, action) => {
    return {
      ...state,
      spaces: action.spaces,
      currentSpace: action.spaces[0] || undefined,
    };
  }),
  on(ConfigurationApiActions.loadSpacesFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  }),
  on(ConfigurationApiActions.loadShifts, (state) => state),
  on(ConfigurationApiActions.loadShiftsSuccess, (state, action) => {
    return {
      ...state,
      shifts: action.shifts,
    };
  }),
  on(ConfigurationApiActions.loadShiftsFailure, (state, action) => {
    return {
      ...state,
      error: action.error,
    };
  }),
  on(ConfigurationApiActions.updateDeviceConfiguration, (state) => {
    return {
      ...state,
      updateDevicesInformation: {
        isFileCorrect: undefined,
        existingAssets: [],
      },
      isUploadSuccessful: undefined,
      loading: true,
    };
  }),
  on(
    ConfigurationApiActions.updateDeviceConfigurationSuccess,
    (state, action) => {
      return {
        ...state,
        updateDevicesInformation: {
          isFileCorrect: action.devicesInformation.isFileCorrect,
          existingAssets: action.devicesInformation.existingAssets,
        },
        isUploadSuccessful: true,
        loading: false,
      };
    }
  ),
  on(
    ConfigurationApiActions.updateDeviceConfigurationFailure,
    (state, action) => {
      return {
        ...state,
        updateDevicesInformation: {
          isFileCorrect: false,
          existingAssets: [],
        },
        isUploadSuccessful: false,
        loading: false,
        error: action.error,
      };
    }
  ),
  on(
    ConfigurationApiActions.updateDeviceConfigurationProgress,
    (state, { progress }) => ({ ...state, progress })
  ),
  on(ConfigurationApiActions.loadDeviceConfiguration, (state) => {
    return {
      ...state,
      isUpdateSuccessful: undefined,
      devicesInformation: {
        tableData: [],
        existingAssets: [],
      },
      updateDevicesInformation: {
        isFileCorrect: undefined,
        existingAssets: [],
      },
      isLoading: true,
    };
  }),
  on(
    ConfigurationApiActions.loadDeviceConfigurationSuccess,
    (state, action) => {
      return {
        ...state,
        devicesInformation: {
          tableData: action.devicesInformation.tableData || [],
          existingAssets: action.devicesInformation.existingAssets,
        },
        isLoading: false,
      };
    }
  ),
  on(
    ConfigurationApiActions.loadDeviceConfigurationFailure,
    (state, action) => {
      return {
        ...state,
        devicesInformation: {
          tableData: [],
          existingAssets: [],
        },
        isLoading: false,
        error: action.error,
      };
    }
  ),
  on(ConfigurationApiActions.updateCSV, (state) => {
    return {
      ...state,
      isUpdateSuccessful: undefined,
    };
  }),
  on(ConfigurationApiActions.updateCSVSuccess, (state, { success }) => {
    return {
      ...state,
      isUpdateSuccessful: success,
    };
  }),
  on(ConfigurationApiActions.updateCSVFailure, (state, action) => {
    return {
      ...state,
      isUpdateSuccessful: false,
      error: action.error,
    };
  }),
  on(ConfigurationApiActions.setTimeZones, (state, action) => {
    return {
      ...state,
      timeZones: [...action.timeZones],
    };
  })
);
